import { useGetCurrentAgentsPresenter } from '@/pages/agents/hooks';
import { useAgentEditorStore } from '@/state/root';
import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';

/**
 * Custom hook to register external fields in the form context and set their changed values
 */
export const useRegisterExternalFields = () => {
    const agentEditorStore = useAgentEditorStore();

    const { register, setValue } = useFormContext();
    const recoilPresenter = useGetCurrentAgentsPresenter();

    useEffect(() => {
        register('presenter');
        register('voice');
        register('is_stitch');
        register('duration');
    }, [register]);

    useEffect(() => {
        setValue('presenter', recoilPresenter, { shouldDirty: true, shouldValidate: true });
    }, [recoilPresenter, setValue]);

    useEffect(() => {
        setValue('voice', agentEditorStore.ttsSelectedVoice, { shouldDirty: true, shouldValidate: true });
    }, [agentEditorStore.ttsSelectedVoice, setValue]);

    useEffect(() => {
        setValue('is_stitch', agentEditorStore.presenterIsStitch, { shouldDirty: true, shouldValidate: true });
    }, [agentEditorStore.presenterIsStitch, setValue]);
};
